import { ComponentProps, ElementType } from 'react';
import { cn } from '@/shared/lib/cn';
import './input-row.scss';

type Props<T extends ElementType = 'label'> = {
    isActive?: boolean;
    as?: T;
} & ComponentProps<T>;
export const InputRow = <T extends ElementType = 'label'>({
    isActive,
    children,
    as: Element = 'label',
    className,
    ...props
}: Props<T>) => {
    return (
        <Element className={cn('input-row', isActive && 'input-row--active', className)} {...props}>
            {children}
        </Element>
    );
};
